(function () {
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.score = 0;
        this.status = "idle";
        this.isStarted = false;
        this.idSeq = 1;
        this.board = this.makeEmptyBoard();
        if (Array.isArray(initialState)) this.board = this.fromNumberBoard(initialState);
        this.initialBoardState = this.cloneBoard(this.board);
        this.lastTilesSnapshot = [];
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "makeEmptyBoard",
            value: function makeEmptyBoard() {
                return Array.from({
                    length: 4
                }, function() {
                    return Array.from({
                        length: 4
                    }, function() {
                        return null;
                    });
                });
            }
        },
        {
            key: "cloneBoard",
            value: function cloneBoard(board) {
                return board.map(function(row) {
                    return row.map(function(cell) {
                        return cell ? {
                            id: cell.id,
                            value: cell.value
                        } : null;
                    });
                });
            }
        },
        {
            key: "fromNumberBoard",
            value: function fromNumberBoard(numBoard) {
                var b = this.makeEmptyBoard();
                for(var r = 0; r < 4; r += 1)for(var c = 0; c < 4; c += 1){
                    var _numBoard_r;
                    var _numBoard_r_c;
                    var v = (_numBoard_r_c = numBoard === null || numBoard === void 0 ? void 0 : (_numBoard_r = numBoard[r]) === null || _numBoard_r === void 0 ? void 0 : _numBoard_r[c]) !== null && _numBoard_r_c !== void 0 ? _numBoard_r_c : 0;
                    if (v && v !== 0) {
                        b[r][c] = {
                            id: this.idSeq,
                            value: v
                        };
                        this.idSeq += 1;
                    }
                }
                return b;
            }
        },
        {
            key: "emptyCells",
            value: function emptyCells(board) {
                var cells = [];
                for(var r = 0; r < 4; r += 1){
                    for(var c = 0; c < 4; c += 1)if (!board[r][c]) cells.push({
                        r: r,
                        c: c
                    });
                }
                return cells;
            }
        },
        {
            key: "generateNewTile",
            value: function generateNewTile(board) {
                var empty = this.emptyCells(board);
                if (empty.length === 0) return null;
                var randomIndex = Math.floor(Math.random() * empty.length);
                var _empty_randomIndex = empty[randomIndex], r = _empty_randomIndex.r, c = _empty_randomIndex.c;
                var value = Math.random() < 0.1 ? 4 : 2;
                var tile = {
                    id: this.idSeq,
                    value: value
                };
                this.idSeq += 1;
                board[r][c] = tile;
                return {
                    tile: tile,
                    row: r,
                    col: c
                };
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var r = 0; r < 4; r += 1)for(var c = 0; c < 4; c += 1){
                    var t = this.board[r][c];
                    if (t && t.value === 2048) {
                        this.status = "win";
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "hasAvailableMoves",
            value: function hasAvailableMoves() {
                for(var r = 0; r < 4; r += 1)for(var c = 0; c < 4; c += 1){
                    if (!this.board[r][c]) return true;
                }
                for(var r1 = 0; r1 < 4; r1 += 1)for(var c1 = 0; c1 < 4; c1 += 1){
                    var _this_board_r_c, _this_board_r_, _this_board__c;
                    var cur = (_this_board_r_c = this.board[r1][c1]) === null || _this_board_r_c === void 0 ? void 0 : _this_board_r_c.value;
                    if (cur == null) continue;
                    if (c1 < 3 && ((_this_board_r_ = this.board[r1][c1 + 1]) === null || _this_board_r_ === void 0 ? void 0 : _this_board_r_.value) === cur) return true;
                    if (r1 < 3 && ((_this_board__c = this.board[r1 + 1][c1]) === null || _this_board__c === void 0 ? void 0 : _this_board__c.value) === cur) return true;
                }
                return false;
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                if (this.checkWin()) return;
                if (!this.hasAvailableMoves()) this.status = "lose";
            }
        },
        {
            key: "snapshotTiles",
            value: function snapshotTiles(board) {
                var flagsById = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Map();
                var tiles = [];
                for(var r = 0; r < 4; r += 1)for(var c = 0; c < 4; c += 1){
                    var t = board[r][c];
                    if (!t) continue;
                    var flags = flagsById.get(t.id) || {};
                    tiles.push({
                        id: t.id,
                        value: t.value,
                        row: r,
                        col: c,
                        isNew: Boolean(flags.isNew),
                        isMerged: Boolean(flags.isMerged)
                    });
                }
                this.lastTilesSnapshot = tiles;
            }
        },
        {
            key: "compressAndMergeLine",
            value: function compressAndMergeLine(line) {
                var filtered = line.filter(Boolean);
                var newLine = [];
                var scoreChange = 0;
                var moved = false;
                var mergedIds = new Set();
                var i = 0;
                while(i < filtered.length){
                    var cur = filtered[i];
                    var next = filtered[i + 1];
                    if (next && next.value === cur.value) {
                        var mergedTile = {
                            id: cur.id,
                            value: cur.value * 2
                        };
                        newLine.push(mergedTile);
                        scoreChange += mergedTile.value;
                        mergedIds.add(mergedTile.id);
                        i += 2;
                    } else {
                        newLine.push({
                            id: cur.id,
                            value: cur.value
                        });
                        i += 1;
                    }
                }
                while(newLine.length < 4)newLine.push(null);
                for(var k = 0; k < 4; k += 1){
                    var a = line[k];
                    var b = newLine[k];
                    var aKey = a ? "".concat(a.id, ":").concat(a.value) : "null";
                    var bKey = b ? "".concat(b.id, ":").concat(b.value) : "null";
                    if (aKey !== bKey) {
                        moved = true;
                        break;
                    }
                }
                return {
                    newLine: newLine,
                    scoreChange: scoreChange,
                    mergedIds: mergedIds,
                    moved: moved
                };
            }
        },
        {
            key: "move",
            value: function move(direction) {
                if (this.status !== "playing") return false;
                var old = this.cloneBoard(this.board);
                var next = this.makeEmptyBoard();
                var flagsById = new Map();
                var boardChanged = false;
                var scoreDelta = 0;
                var mergedAll = new Set();
                var take = function(r, c) {
                    return old[r][c];
                };
                var writeRow = function(r, arr) {
                    for(var c = 0; c < 4; c += 1)next[r][c] = arr[c];
                };
                var writeCol = function(c, arr) {
                    for(var r = 0; r < 4; r += 1)next[r][c] = arr[r];
                };
                if (direction === "left" || direction === "right") for(var r = 0; r < 4; r += 1){
                    var line = [
                        take(r, 0),
                        take(r, 1),
                        take(r, 2),
                        take(r, 3)
                    ];
                    if (direction === "right") line = line.reverse();
                    var _this_compressAndMergeLine = this.compressAndMergeLine(line), newLine = _this_compressAndMergeLine.newLine, scoreChange = _this_compressAndMergeLine.scoreChange, mergedIds = _this_compressAndMergeLine.mergedIds, moved = _this_compressAndMergeLine.moved;
                    scoreDelta += scoreChange;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = mergedIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var id = _step.value;
                            mergedAll.add(id);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (moved) boardChanged = true;
                    var finalLine = direction === "right" ? newLine.reverse() : newLine;
                    writeRow(r, finalLine);
                }
                else for(var c = 0; c < 4; c += 1){
                    var line1 = [
                        take(0, c),
                        take(1, c),
                        take(2, c),
                        take(3, c)
                    ];
                    if (direction === "down") line1 = line1.reverse();
                    var _this_compressAndMergeLine1 = this.compressAndMergeLine(line1), newLine1 = _this_compressAndMergeLine1.newLine, scoreChange1 = _this_compressAndMergeLine1.scoreChange, mergedIds1 = _this_compressAndMergeLine1.mergedIds, moved1 = _this_compressAndMergeLine1.moved;
                    scoreDelta += scoreChange1;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = mergedIds1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var id1 = _step1.value;
                            mergedAll.add(id1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (moved1) boardChanged = true;
                    var finalLine1 = direction === "down" ? newLine1.reverse() : newLine1;
                    writeCol(c, finalLine1);
                }
                if (!boardChanged) {
                    this.snapshotTiles(this.board);
                    return false;
                }
                this.score += scoreDelta;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = mergedAll[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var id2 = _step2.value;
                        flagsById.set(id2, (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, flagsById.get(id2) || {}), {
                            isMerged: true
                        }));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var spawned = this.generateNewTile(next);
                if (spawned) flagsById.set(spawned.tile.id, {
                    isNew: true,
                    isMerged: false
                });
                this.board = next;
                this.checkGameStatus();
                this.snapshotTiles(this.board, flagsById);
                return true;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                return this.move("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                return this.move("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                return this.move("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                return this.move("down");
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return row.map(function(cell) {
                        return cell ? cell.value : 0;
                    });
                });
            }
        },
        {
            key: "getTiles",
            value: function getTiles() {
                if (!this.lastTilesSnapshot || this.lastTilesSnapshot.length === 0) this.snapshotTiles(this.board);
                return this.lastTilesSnapshot;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = this.cloneBoard(this.initialBoardState);
                this.score = 0;
                var flags = new Map();
                var a = this.generateNewTile(this.board);
                var b = this.generateNewTile(this.board);
                if (a) flags.set(a.tile.id, {
                    isNew: true
                });
                if (b) flags.set(b.tile.id, {
                    isNew: true
                });
                this.status = "playing";
                this.isStarted = true;
                this.snapshotTiles(this.board, flags);
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.status = "idle";
                this.isStarted = false;
                this.start();
            }
        }
    ]);
    return Game;
}();


var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$tilesLayer = document.querySelector(".tiles");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$startButton = document.querySelector(".button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$CELL = 75;
var $197cd56b15c33885$var$GAP = 10;
var $197cd56b15c33885$var$tileEls = new Map();
function $197cd56b15c33885$var$hideAllMessages() {
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
}
function $197cd56b15c33885$var$pos(row, col) {
    return {
        x: col * ($197cd56b15c33885$var$CELL + $197cd56b15c33885$var$GAP) + $197cd56b15c33885$var$GAP,
        y: row * ($197cd56b15c33885$var$CELL + $197cd56b15c33885$var$GAP) + $197cd56b15c33885$var$GAP
    };
}
function $197cd56b15c33885$var$createTileEl(tile) {
    var el = document.createElement("div");
    el.className = "tile tile--".concat(tile.value);
    el.dataset.id = String(tile.id);
    var inner = document.createElement("div");
    inner.className = "tile__inner";
    inner.textContent = String(tile.value);
    el.appendChild(inner);
    $197cd56b15c33885$var$tilesLayer.appendChild(el);
    return el;
}
function $197cd56b15c33885$var$setTilePosition(el, row, col) {
    var _pos = $197cd56b15c33885$var$pos(row, col), x = _pos.x, y = _pos.y;
    el.style.transform = "translate(".concat(x, "px, ").concat(y, "px)");
}
function $197cd56b15c33885$var$updateBoard() {
    var tiles = $197cd56b15c33885$var$game.getTiles();
    var nextIds = new Set(tiles.map(function(t) {
        return t.id;
    }));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $197cd56b15c33885$var$tileEls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $efec029548ccee7f$export$71511d61b312f219)(_step.value, 2), id = _step_value[0], el = _step_value[1];
            if (!nextIds.has(id)) {
                el.remove();
                $197cd56b15c33885$var$tileEls.delete(id);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop = function() {
            var t = _step1.value;
            var el = $197cd56b15c33885$var$tileEls.get(t.id);
            if (!el) {
                el = $197cd56b15c33885$var$createTileEl(t);
                $197cd56b15c33885$var$tileEls.set(t.id, el);
                $197cd56b15c33885$var$setTilePosition(el, t.row, t.col);
                var inner = el.querySelector(".tile__inner");
                if (t.isNew) {
                    inner.classList.add("tile__inner--spawn");
                    window.setTimeout(function() {
                        return inner.classList.remove("tile__inner--spawn");
                    }, 180);
                }
            }
            el.className = "tile tile--".concat(t.value);
            var inner1 = el.querySelector(".tile__inner");
            inner1.textContent = String(t.value);
            requestAnimationFrame(function() {
                $197cd56b15c33885$var$setTilePosition(el, t.row, t.col);
            });
            if (t.isMerged) {
                inner1.classList.add("tile__inner--merge");
                window.setTimeout(function() {
                    return inner1.classList.remove("tile__inner--merge");
                }, 220);
            }
        };
        for(var _iterator1 = tiles[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$scoreElement.textContent = String($197cd56b15c33885$var$game.getScore());
}
function $197cd56b15c33885$var$updateStatus() {
    var st = $197cd56b15c33885$var$game.getStatus();
    if ($197cd56b15c33885$var$game.isStarted) {
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    } else {
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$startButton.classList.add("start");
        $197cd56b15c33885$var$startButton.classList.remove("restart");
    }
    $197cd56b15c33885$var$hideAllMessages();
    if (st === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if (st === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    else if (st === "idle") $197cd56b15c33885$var$messageStart.classList.remove("hidden");
}
function $197cd56b15c33885$var$updateUI() {
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$updateStatus();
}
function $197cd56b15c33885$var$resetUiTiles() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $197cd56b15c33885$var$tileEls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $efec029548ccee7f$export$71511d61b312f219)(_step.value, 2), el = _step_value[1];
            el.remove();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $197cd56b15c33885$var$tileEls.clear();
}
function $197cd56b15c33885$var$handleStartClick() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing" || $197cd56b15c33885$var$game.isStarted) {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$resetUiTiles();
    } else $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$updateUI();
}
function $197cd56b15c33885$var$handleKeyDown(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    if (moved) {
        e.preventDefault();
        $197cd56b15c33885$var$updateUI();
    }
}
function $197cd56b15c33885$var$init() {
    if (!$197cd56b15c33885$var$startButton || !$197cd56b15c33885$var$gameField || !$197cd56b15c33885$var$scoreElement || !$197cd56b15c33885$var$tilesLayer) return;
    $197cd56b15c33885$var$startButton.addEventListener("click", $197cd56b15c33885$var$handleStartClick);
    document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
    $197cd56b15c33885$var$updateUI();
}
$197cd56b15c33885$var$init();

})();
//# sourceMappingURL=index.63033739.js.map
